import {
  ProductThumbnail,
  View,
  useThemeProvider,
  Text,
  SkeletonView,
  VStack,
} from "@towersystems/roam-common-native";
import { Product } from "@towersystems/roam-common/lib/generated-types";
import { toTitleCase } from "../../../../utilities/to-title-case";
import { StyleSheet } from "react-native";

export interface ProductPreviewProps {
  product?: Product;
  loading?: boolean;
}

const IMAGE_SIZE = 80;

export function ProductPreview({
  product,
  loading = false,
}: ProductPreviewProps) {
  const { spacings } = useThemeProvider();

  return (
    <View style={styles.productContainer}>
      <View style={{ marginRight: spacings.s5 }}>
        {loading ? (
          <View>
            <SkeletonView height={IMAGE_SIZE} width={IMAGE_SIZE} />
          </View>
        ) : (
          <ProductThumbnail
            size="large"
            imageUrl={product?.image?.path}
            hideQuantity
          />
        )}
      </View>
      <View style={styles.productTextContainer} flexS>
        {loading ? (
          <VStack spacing={spacings.s2}>
            <SkeletonView textVariant="heading" width={160} />
            <SkeletonView textVariant="heading5" width={120} />
          </VStack>
        ) : (
          <>
            <Text
              variant="heading"
              fontWeight="medium"
              numberOfLines={2}
              ellipsizeMode="head"
            >
              {toTitleCase(product?.name || "Unknown product")}
            </Text>
            {product?.displayName ? (
              <Text color="subdued" variant="heading5">
                {product.displayName}
              </Text>
            ) : undefined}
          </>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  productContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  productTextContainer: { width: "100%" },
});
